import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const generateValuationURL = createAsyncThunk(
  "agentProfile/generateValuationURL",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/users/home-valuation-data?user_id=${data.userId}`,

        {
          headers: {
                  Authorization: "Bearer " + localStorage.token,
            "Content-Type": "application/json",
          },
        }
      );
      if (data?.handleSuccess) {
        data.handleSuccess(resp.data.data);
      }
      return resp.data.data;
    } catch (error) {
      if (error.response) {
        data.handleError(
          error.response.data.errorMessage || error.response.data.message
        );
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        data.handleError(error.message);
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
